import { render, staticRenderFns } from "./TableDataWidget.vue?vue&type=template&id=68b3612c&"
import script from "./TableDataWidget.vue?vue&type=script&lang=js&"
export * from "./TableDataWidget.vue?vue&type=script&lang=js&"
import style0 from "./TableDataWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports